import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeFirestoreTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalString,
  nullSafeOptionalStringArray,
} from '../shared/schema'

export const schema = z.object({
  sectionId: nullSafeOptionalString(),
  assignmentId: nullSafeOptionalString(),
  conversationId: nullSafeOptionalString(),
  complete: nullSafeOptionalBoolean(),
  role: nullSafeOptionalString(),
  eventIds: nullSafeOptionalStringArray(),
  filteredRoomIds: nullSafeOptionalStringArray(),
  filteredUserIds: nullSafeOptionalStringArray(),
  imageHttpPath: nullSafeOptionalString(),
  userContent: nullSafeOptionalString(),
  createdAt: nullSafeFirestoreTimestamp(),
  updatedAt: nullSafeFirestoreTimestamp(),
  userId: nullSafeOptionalString(),
})

export const writeSchema = schema.extend({
  createdAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(schema.parse({}))

export interface FirestoreSectionAssignmentConversationItem extends z.infer<
  typeof schema
> {}
